import { render, staticRenderFns } from "./CatArts.vue?vue&type=template&id=5ad5a289"
import script from "./CatArts.vue?vue&type=script&lang=js"
export * from "./CatArts.vue?vue&type=script&lang=js"
import style0 from "./CatArts.vue?vue&type=style&index=0&id=5ad5a289&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports